import { render, staticRenderFns } from "./ReservationCard.vue?vue&type=template&id=648be40f&scoped=true&"
import script from "./ReservationCard.vue?vue&type=script&lang=js&"
export * from "./ReservationCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCard.vue?vue&type=style&index=0&id=648be40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648be40f",
  null
  
)

export default component.exports